import { ActionControllerEventName, ResourcesManager, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import { Box3, BoxGeometry, Material, Mesh, MeshBasicMaterial, Vector3 } from 'three';
import { deepClone } from '@verybigthings/vbt-webvr-framework/build/main/ts/utils/DeepClone';
import { PickingControllerEvents } from '@verybigthings/vbt-webvr-framework/build/main/ts/controls/PickingController';
import { PreparationPickingObjects } from '../../utils/PreparationPickingObjects';
export class SpoonModule extends ViewerModule {
    constructor(level, weight) {
        super();
        this.level = level;
        this.weight = weight;
        this.addedSalt = false;
        this.numericalWeight = +this.weight;
    }
    init() {
        if (this.model)
            this.removeObject(this.model);
        this.addObject(this.model = this.getModel(false));
        this.model.position.set(0, 0.1, -0.6);
        // @ts-ignore
        this.model.children[0].material.shininess = 0;
        this.model.children[0].material.color.set(0x654321);
        this.addedSalt = false;
        const box3Size = new Box3().setFromObject(this.model).getSize(new Vector3());
        box3Size.multiplyScalar(1.18);
        const spoonInnerWrap = new Mesh(new BoxGeometry(box3Size.x, box3Size.y, box3Size.z), new MeshBasicMaterial({ visible: false }));
        this.model.add(spoonInnerWrap);
    }
    addSalt() {
        if (this.model)
            this.removeObject(this.model);
        this.addObject(this.model = this.getModel(true));
        let spoonHandle;
        this.model.traverse(el => {
            if (el.isMesh && el.name.includes('pSphere'))
                spoonHandle = el;
        });
        // @ts-ignore
        spoonHandle.material.shininess = 0;
        spoonHandle.material.color.set(0x654321);
        this.model.position.set(0, 0.1, -0.6);
        this.addedSalt = true;
    }
    removeSalt() {
        if (this.model)
            this.removeObject(this.model);
        this.addObject(this.model = this.getModel(false));
        // @ts-ignore
        this.model.children[0].material.shininess = 0;
        this.model.children[0].material.color.set(0x654321);
        this.model.position.set(0, 0.1, -0.6);
        this.addedSalt = false;
    }
    setDraggable(value) {
        if (!value) {
            this.actionController.off(ActionControllerEventName.click, this.uiObject);
            if (this.level.lobby.app.zSpacePickingController) {
                this.level.lobby.app.zSpacePickingController.off(null, this.uiObject);
            }
            return;
        }
        if (!this.uiObject.userData.prevPosition)
            PreparationPickingObjects.saveObjectState(this.uiObject);
        if (!Viewer.controls.zController) {
            this.tableEvent && this.actionController && this.actionController.off(ActionControllerEventName.click, this.level.table, this.tableEvent);
            this.actionController.on(ActionControllerEventName.click, this.level.table, this.tableEvent = (event) => {
                if (this.level.lobby.app.pointerController.currentPointerObject !== this.uiObject
                    || event.orderNumber > 0
                    || (event.intersectedObject.name !== 'table1' && event.intersectedObject.name !== 'pPlane'))
                    return;
                this.level.lobby.app.pointerController.setObject(null);
                if (this.addedSalt)
                    this.addSalt();
                else
                    this.removeSalt();
                this.uiObject.position.copy(this.uiObject.userData.prevPosition);
                this.uiObject.quaternion.copy(this.uiObject.userData.prevQuaternion);
                this.uiObject.scale.copy(this.uiObject.userData.prevScale);
                this.uiObject.userData.prevParent.add(this.uiObject);
                this.fire('onTable');
            });
            this.actionController && this.actionController.off(ActionControllerEventName.click, this.uiObject);
            this.actionController.on(ActionControllerEventName.click, this.uiObject, () => {
                setTimeout(() => {
                    // @ts-ignore
                    if (this.level.lobby.app.pointerController.currentPointerObject
                        === this.level.lobby.app.pointerController.defaultPointerObject) {
                        // this.model.position.y += 0.1;
                        this.level.lobby.app.pointerController.setObject(this.uiObject);
                    }
                });
            });
        }
        else {
            this.level.lobby.app.zSpacePickingController.off(null, this.uiObject);
            this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.PICKED, this.uiObject, () => {
                if (!this.level.interaction)
                    return;
                Viewer.scene.add(this.uiObject);
                this.uiObject.traverse(el => {
                    el.userData.oldRaycast = el.raycast;
                    el.raycast = () => { };
                });
                this.fire('took');
            });
            this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.RELEASED, this.uiObject, () => {
                this.uiObject.position.copy(this.uiObject.userData.prevPosition);
                this.uiObject.quaternion.copy(this.uiObject.userData.prevQuaternion);
                this.uiObject.scale.copy(this.uiObject.userData.prevScale);
                this.uiObject.userData.prevParent.add(this.uiObject);
                if (this.addedSalt)
                    this.addSalt();
                else
                    this.removeSalt();
                this.fire('onTable');
            });
        }
    }
    reset() {
        this.actionController &&
            this.actionController.off(null, this.model);
        this.actionController &&
            this.actionController.off(null, this.uiObject);
        this.actionController && this.actionController.off(ActionControllerEventName.click, this.level.table, this.tableEvent);
        this.level.lobby.app.zSpacePickingController &&
            this.level.lobby.app.zSpacePickingController.off(null, this.uiObject);
        this.off();
        this.init();
    }
    getModel(salt) {
        let name;
        name = 'spoon_';
        if (this.weight === '0.5')
            name += '0_5';
        if (this.weight === '0.1')
            name += '0_1';
        if (this.weight === '1.0')
            name += '1';
        if (salt)
            name += '_w_salt';
        const model = deepClone(ResourcesManager.getModel(name).clone());
        let texture;
        if (this.weight === '0.5')
            texture = ResourcesManager.getTexture('TEXTURE_spoon_0_5');
        if (this.weight === '0.1')
            texture = ResourcesManager.getTexture('TEXTURE_spoon_0_1');
        if (this.weight === '1.0')
            texture = ResourcesManager.getTexture('TEXTURE_spoon_1');
        model.traverse(obj => {
            if (obj instanceof Mesh) {
                if (obj.material instanceof Material && obj.material.name.indexOf('ai') > -1) {
                    // @ts-ignore
                    obj.material.map = texture;
                    // @ts-ignore
                    obj.material.color.set(0x999999);
                }
            }
        });
        if (this.level.lobby.app.pointerController.currentPointerObject === this.uiObject)
            model.traverse(el => {
                el.userData.oldRaycast = el.raycast;
                el.raycast = () => {
                };
            });
        return model;
    }
}
